import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3002'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 secondes
  headers: {
    'Content-Type': 'application/json',
  },
})

// Intercepteur pour les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Erreur de réponse du serveur
      const message = error.response.data?.error || 'Erreur du serveur'
      throw new Error(message)
    } else if (error.request) {
      // Erreur de réseau
      throw new Error('Impossible de contacter le serveur')
    } else {
      // Autre erreur
      throw new Error('Erreur inattendue')
    }
  }
)

export const apiService = {
  // Vérifier la santé du serveur
  async checkHealth() {
    const response = await api.get('/health')
    return response.data
  },

  // Générer une image
  async generateImage({ prompt, image, mimeType, imageCount = 1, targetPerson = 'main' }) {
    const response = await api.post('/api/generate', {
      prompt,
      image,
      mimeType,
      imageCount,
      targetPerson
    })
    return response.data
  },

  // Mode démo
  async generateDemo({ prompt, image, mimeType }) {
    const response = await api.post('/api/demo', {
      prompt,
      image,
      mimeType
    })
    return response.data
  }
}

export default api
